import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup }                 from '@angular/forms';
import { NgForm } from '@angular/forms';
import { SeguridadService } from '../_services/seguridad.service'
import { Subscription } from 'rxjs/Subscription';
import { ModalDirective } from 'ng2-bootstrap/modal';

import {GlobalEventsManager} from "../_services/globaleventsmanager.service";

import { CuestionarioService } from "../_services/cuestionario.service";

import { Nivel } from '../_models/nivel.model';
import { Pregunta } from '../_models/pregunta.model';
import { Cuestionario } from '../_models/cuestionario.model';

@Component({
  selector: 'cuestionariofull',
  templateUrl: 'cuestionariofull.template.html'
})
export class CuestionarioFullComponent  implements OnInit, OnDestroy {

  @ViewChild('staticModalEvidencias') public staticModalEvidencias:ModalDirective;

  subscription: Subscription;

  id_cuestionario: number = 1;
  cuestionario: Cuestionario;

  constructor(private seguridad: SeguridadService,
              private router:Router,
              private cuestionarioService: CuestionarioService,
              private globalEventsManager: GlobalEventsManager,
              private activatedRoute: ActivatedRoute){

  }

  cerrarModal(){
    this.staticModalEvidencias.hide();
  }

  abrirModal(){
    this.staticModalEvidencias.show();
  }

  ngOnInit(){

    this.seguridad.getLogado();

    this.subscription = this.seguridad.dejoPasarUsuarioEmitter.subscribe((mode)=>{
            if (mode !== null) {
              if (!mode){
                this.router.navigate(['login']);
              }
            }
        });

    let _id_cuestionario = this.activatedRoute.snapshot.params["id"];
    if (_id_cuestionario){
      this.id_cuestionario = _id_cuestionario;
    }

    this.globalEventsManager.menuExtendido(true);

    let breadcrumb: any = [{
      'path':'#',
      'name':'Test Cuestionario'
    }];

    this.getCuestionario();

  }

  ngOnDestroy(){
    this.subscription.unsubscribe();
  }

  getCuestionario(){
    this.cuestionarioService.getFullCuestionario(this.id_cuestionario).subscribe(
      data => {
        if (data){

          console.log(data.json());

        }
      }
    );
  }

}



// WEBPACK FOOTER //
// ./src/app/cuestionario/cuestionariofull.component.ts